import React, { useEffect, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { eventSelector, chatSelector } from 'src/selectors'
import {
  disconnectSocket,
  createSocket,
  subscribeChannel,
  pushChannel,
  resetSocket
} from 'services/websocket'
import { ROOM_CHANNEL_TYPES_CONSTANTS, POPUP_BOX_TYPES_CONSTANTS } from 'src/constants'
import ViewMessage from './ViewMessage/ViewMessage'
import InputMessage from './InputMessage/InputMessage'
import {
  addMessage,
  updateMessage,
  getGroupList,
  deleteMessage,
  changeChatStatus
} from 'src/actions/eventChat'
import { PageContainerContext } from 'services/contexts'
import { changeEventsModal } from 'src/actions/event'
import LoadingComponent from 'src/components/common/LoadingComponent/LoadingComponent'
import Button from 'components/common/Button'
import styles from './event-chat.scss'

const EventChat = () => {
  const dispatch = useDispatch()
  const event = useSelector(eventSelector)
  const chat = useSelector(chatSelector)
  const { onChangePopupBox, onChangePopupBoxCallBack } = useContext(PageContainerContext)

  useEffect(() => {
    history.pushState(null, null, location.href)
    onChangePopupBox(POPUP_BOX_TYPES_CONSTANTS.eventComments)
    onChangePopupBoxCallBack(() => dispatch(changeEventsModal('details')))
    dispatch(changeChatStatus('connecting'))

    if (chat.socketInstance && chat.socketId === event.id) {
      chat.socketInstance.connect()
    } else {
      resetSocket(dispatch)
      createSocket({ dispatch, event })
    }

    return disconnectSocket
  }, [])

  useEffect(() => {
    if (chat.socketInstance) {
      // fetch group
      pushChannel({
        channelName: event.messages_channel,
        action: ROOM_CHANNEL_TYPES_CONSTANTS.room_mention_groups,
        successCallback: data => {
          const implicit_groups = data.implicit_groups.map(item => ({
            ...item,
            groupName: 'implicit_group'
          }))
          const user_groups = data.user_groups.map(item => ({ ...item, groupName: 'user_group' }))
          const groupList = implicit_groups.concat(user_groups)

          dispatch(getGroupList(groupList))
        }
      })

      subscribeChannel({
        channelName: event.messages_channel,
        subscriberList: [
          {
            action: ROOM_CHANNEL_TYPES_CONSTANTS.listen_new_message,
            onReceived: ({ message }) => {
              console.log('message:', message)
              dispatch(addMessage(message))
            }
          },
          {
            action: ROOM_CHANNEL_TYPES_CONSTANTS.message_update,
            onReceived: ({ message }) => {
              console.log('message:', message)
              dispatch(updateMessage(message))
            }
          },
          {
            action: ROOM_CHANNEL_TYPES_CONSTANTS.message_read,
            onReceived: data => {
              console.log('data', data)
              // console.log('message:', message)
              // dispatch(updateMessage(message))
            }
          },
          {
            action: ROOM_CHANNEL_TYPES_CONSTANTS.message_destroy,
            onReceived: ({ message }) => {
              console.log('message:', message)
              dispatch(deleteMessage(message))
            }
          }
        ]
      })
    }

    const watchVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log('回到前端页面')
        dispatch(changeChatStatus('connecting'))

        if (chat.socketInstance) {
          window.eventChatTimeout = setTimeout(() => {
            if (chat.chatStatus === 'connecting') {
              dispatch(changeChatStatus('disconnected'))
            }
          }, 5000)

          chat.socketInstance.connect()
        } else {
          createSocket({ dispatch, event })
        }
      } else {
        console.log('离开前端页面')
        if (window.eventChatTimeout) {
          clearTimeout(window.eventChatTimeout)
          window.eventChatTimeout = null
        }
        chat.socketInstance.disconnect()
      }
    }
    document.addEventListener('visibilitychange', watchVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', watchVisibilityChange)
    }
  }, [chat.socketInstance])

  const renderLoadingContent = () => {
    let content = 'Connecting'
    if (chat.chatStatus === 'disconnected') {
      const handleReconnect = () => {
        dispatch(changeChatStatus('connecting'))

        if (chat.socketInstance) {
          chat.socketInstance.connect()
        } else {
          createSocket({ dispatch, event })
        }
      }

      content = (
        <Button className={styles['reconnect-button']} onClick={handleReconnect}>
          RECONNECT
        </Button>
      )
    }

    return (
      <div className={styles['loading-component']}>
        <LoadingComponent loading type="partial" light content={content} />
      </div>
    )
  }

  const renderChatErrorMask = () => {
    return (
      <div className={styles['chat-error-mask']}>
        <div>Session Expired</div>
        <Button className={styles['reconnect-button']} onClick={() => location.reload()}>
          REFRESH PAGE
        </Button>
      </div>
    )
  }

  const isChatConnecting = chat.chatStatus === 'connecting' || chat.chatStatus === 'disconnected'
  const isChatError = chat.chatStatus === 'connection_error'
  return (
    <div className={styles['event-chat-container']}>
      <ViewMessage />
      <InputMessage />
      {isChatConnecting && renderLoadingContent()}
      {isChatError && renderChatErrorMask()}
    </div>
  )
}

export default EventChat
